import { DateTime } from '@ksyos/date-time';
import type { NonEmptyArray } from '@common/utils/nonEmptyArray';
import type { Stringified } from '@common/utils/stringify';
import { findActiveItem } from '@common/utils/dates';
import { parseStringified } from '@common/utils/stringify';

export type AgbCode = {
    agbCode: string;
    endDate: string | null;
    startDate: string;
};

export function isAgbCodeList(codes: unknown): codes is NonEmptyArray<AgbCode> {
    if (!Array.isArray(codes) || codes.length === 0) {
        return false;
    }

    return codes.every(isAgbCode);
}

export function isAgbCode(code: unknown): code is AgbCode {
    return (
        (typeof code !== 'object' ||
            code === null ||
            'agbCode' in code === false ||
            'startDate' in code === false ||
            'endDate' in code === false ||
            typeof code.agbCode !== 'string' ||
            typeof code.startDate !== 'string' ||
            new Date(code.startDate).toString() === 'Invalid Date' ||
            (code.endDate !== null &&
                (typeof code.endDate !== 'string' || new Date(code.endDate).toString() === 'Invalid Date'))) === false
    );
}

export function findActiveAgbCode(
    agbCodes: AgbCode[] | Stringified<AgbCode[]> | null | undefined,
    date: Date | string = new Date()
): AgbCode | undefined {
    if (!agbCodes) {
        return undefined;
    }

    const startOfDay = DateTime.from(date).startOf('day').toDate();
    const agbCodesList = Array.isArray(agbCodes) ? agbCodes : parseStringified(agbCodes);

    return isAgbCodeList(agbCodesList) ? findActiveItem(agbCodesList, startOfDay) : undefined;
}
